<template>
  <div>
    <b-row>
      <div class="col-md-6" v-for="(field, index) in schema" :key="index">
        <component :is="field.fieldType"
                  :value="value[field.name]"
                  @input="updateForm(field.name, $event)"
                  v-bind="field">
        </component>
      </div>
    </b-row>
  </div>
</template>

<script>
import NumberInput from "./NumberInput";
import SelectList from "./SelectList";
import TextInput from "./TextInput";
import TextAreaInput from "./TextAreaInput";
import DateInput from "./DateInput";
export default {
  name: "FormGenerator",
  components: { NumberInput, SelectList, TextInput, TextAreaInput, DateInput },
  props: ["schema", "value"],
  data() {
    return {
      formData: this.value || {}
    };
  },
  methods: {
    updateForm(fieldName, value) {
      this.$set(this.value, fieldName, value);
      this.$emit("input", this.value);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Generator/FormGenerator.vue